import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  CrossPlatformLocationIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description:
      "Our Android app development involves the use of Java and Kotlin languages to create stable and efficient applications. By using Android Studio, we incorporate the Material Design guidelines, and native APIs, and adapt them to various devices. Some of the things we do include testing, improving security, and optimizing for release on the Google Play Store.",
  },
  {
    icon: IphoneIcon,
    title: "Iphone App Development",
    description:
      "Our core competency is iOS application development using Swift and Objective-C on Xcode platform. Our team creates powerful apps that meet the principles of Apple’s Human Interface Guidelines. We incorporate Core Data, ARKit, and other native features, making the app fully compatible with iOS systems. Our apps are designed for the App Store and rigorously tested for functionality and security.",
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description:
      "Our game app development is done using Unity and Unreal Engine for the purpose of compatibility across multiple platforms. We use C# and C++ for performance enhancement, physics engines, and visual effects. With services such as UI/UX design for the game, multiplayer integration, and monetization strategies, the game will be very attractive to the users.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description:
      "The Flutter app development we offer employs Dart to build natively compiled applications for mobile, web, and desktop. Our focus is on using a single codebase and Flutter widgets for the UI as we have seen in the examples. It includes state management, the ability to easily work with Firebase, and thorough testing of the application’s stability and speed.",
  },
  {
    icon: CrossPlatformLocationIcon,
    title: "Cross-Platform App Development",
    description:
      "We provide cross platform mobile application development using React Native and Flutter. By using our approach, we guarantee a stable performance and a unified look and feel on both platforms, iOS and Android. We combine platform-specific components, design for multiple resolutions, and extensively test a single codebase, thus lowering development time and costs.",
  },
  {
    icon: ReactIcon,
    title: "React Native app development",
    description:
      "Our React Native app development involves the use of JavaScript and TypeScript for creating applications that are compatible with multiple platforms. Our strengths include native modules, performance, and Redux state management. It results in high-quality applications with fast refresh rates and applications that are consistent across both iOS and Android platforms.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our User-centric Mobile App Development Services in San Francisco
            </h2>
            <p className="impro_para">
              Get your hands on our dynamic San Francisco mobile app development
              services. Ensure your business’s digital success through
              high-performing and interactive mobile apps for maximum user
              engagement. From initial conceptualization to the core development
              of your full-fledged application, we offer the following services:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
